import { Td, Tr } from "@chakra-ui/react";
import { SituationModel } from "../../clients/BackOfficeApi";
import { LinkButton } from "../../elements/LinkButton";
import { SituationActions } from "./SituationActions";
import { VisibilityIcon } from "../../elements/VisibilityIcon";

interface Props {
  situation: SituationModel;
  includeResidenceTypeDetails?: boolean;
  onChange?: () => void;
}

export function SituationListRow({
  situation,
  includeResidenceTypeDetails = false,
  onChange = () => {},
}: Props) {
  return (
    <Tr key={situation.id}>
      <Td>
        <LinkButton to={`/situations/${situation.id}`}>
          {situation.id}
        </LinkButton>
      </Td>
      {includeResidenceTypeDetails && (
        <Td>
          <LinkButton to={`/residence-types/${situation.residenceTypeId}`}>
            {situation.residenceTypeName}
          </LinkButton>
        </Td>
      )}
      <Td>{situation.orientation}</Td>
      <Td>{situation.relativePosition}</Td>
      <Td>{situation.scenarioCount}</Td>
      <Td>
        <VisibilityIcon visibility={situation.visibility} />
      </Td>
      <Td>
        <SituationActions forCell onChange={onChange} situation={situation} />
      </Td>
    </Tr>
  );
}
